<template>
  <div id="engine-decks-list">
    <div class="container">
      <h1 class="mt-4">Decks</h1>
      <button @click="createDeck()" class="btn btn-outline-secondary"><i class="fal fa-file-plus"></i> New Deck</button>
      <b-table striped hover dark :items="decks" :fields="[{key:'name', sortable:true}, 'edit']" class="mt-4">
        <!-- A virtual column -->
        <template slot="edit" slot-scope="data">
          <button @click="editDeck(data.item.id)" class="btn btn-sm btn-outline-secondary"><i class="fal fa-edit"></i></button>
        </template>
      </b-table>
    </div><!-- /.container -->

    <EngineDeckBuilder :deckId="editThisDeck" v-on:closeDeckBuilder="showDeckBuilder = false" v-if="showDeckBuilder == true" />
  </div>
</template>

<script>
const fb = require('../../firebaseConfig.js')
import EngineDeckBuilder from './EngineDeckBuilder.vue'

export default {
  data() {
    return {
      decks: [],
      editThisDeck: null,
      showDeckBuilder: false
    }
  },
  components: {
    EngineDeckBuilder
  },
  created() {
    fb.decksCollection.orderBy("updatedOn", "desc").onSnapshot(decks => {
      this.decks = []
      for (let i = 0; i < decks.docs.length; i++) {
        let deckItem = decks.docs[i].data()
        deckItem.id = decks.docs[i].id
        this.decks.push(deckItem)
      }
    })
  },
  methods: {
    editDeck(id) {
      this.editThisDeck = id
      this.showDeckBuilder = true
    },
    createDeck() {
      this.editThisDeck = null
      this.showDeckBuilder = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/engine/EngineDecksList.vue